module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetHigh@2x.50fbaa8.webp";